import type { Commodity } from "~/shared/schemas/commodity-schema.ts";

export type SearchableCommodity = Omit<
	Commodity,
	"freightClass" | "unitType" | "isStackable" | "isHazmat" | "dimensions"
> & {
	freightClass: Commodity["freightClass"] | string;
	unitType: Commodity["unitType"] | string;
	isStackable: Commodity["isStackable"] | string;
	isHazmat: Commodity["isHazmat"] | string;
	dimensions: string;
	originalFreightClass: Commodity["freightClass"];
	originalUnitType: Commodity["unitType"];
	originalIsStackable: Commodity["isStackable"];
	originalIsHazmat: Commodity["isHazmat"];
	originalDimensionLength: Commodity["dimensionLength"];
	originalDimensionWidth: Commodity["dimensionWidth"];
	originalDimensionHeight: Commodity["dimensionHeight"];
};

const createDimensionSearchText = (
	length?: number | null,
	width?: number | null,
	height?: number | null,
): string => {
	const display = `${length ?? 0} x ${width ?? 0} x ${height ?? 0}`;
	return `${display} ${length ?? 0} ${width ?? 0} ${height ?? 0}`;
};

export const transformCommodityForSearch = (
	item: Commodity,
): SearchableCommodity => ({
	...item,
	// Store original values for display/editing
	originalFreightClass: item.freightClass,
	originalUnitType: item.unitType,
	originalIsStackable: item.isStackable,
	originalIsHazmat: item.isHazmat,
	originalDimensionLength: item.dimensionLength,
	originalDimensionWidth: item.dimensionWidth,
	originalDimensionHeight: item.dimensionHeight,
	// Override fields with searchable content for filtering
	freightClass: item.freightClass?.code || "",
	unitType: item.unitType?.name || "",
	isStackable: item.isStackable ? "Yes Yes" : "No No",
	isHazmat: item.isHazmat ? "Yes Yes" : "No No",
	dimensions: createDimensionSearchText(
		item.dimensionLength,
		item.dimensionWidth,
		item.dimensionHeight,
	),
});
